/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Attachment_TitleInputs */

const es_walkthrough_attachment_title = /** @type {(inputs: Walkthrough_Attachment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjuntos`)
};

const en_walkthrough_attachment_title = /** @type {(inputs: Walkthrough_Attachment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachments`)
};

/**
* | output |
* | --- |
* | "Attachments" |
*
* @param {Walkthrough_Attachment_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_attachment_title = /** @type {((inputs?: Walkthrough_Attachment_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Attachment_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_attachment_title(inputs)
	return en_walkthrough_attachment_title(inputs)
});
export { walkthrough_attachment_title as "walkthrough.attachment_title" }